<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OoTcBE/tc-custom/9781504006545.jpg?1737194628591" alt="This image is the cover for the book Joe Dallesandro"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Joe Dallesandro
      </h1>
      <p class="bookDescription body article font2">
        <b>The story of Warhol’s greatest superstar</b><br/><br/> The renowned photographer Francesco Scavullo has called Joe Dallesandro “one of the ten most photogenic men in the world.” Springing to fame at the beginning of the sexual revolution in films such as <i>Flesh</i>, <i>Trash</i>, and <i>Heat</i>, Dallesandro, with the help of his mentor, Paul Morrissey, and pop artist Andy Warhol, became a male sex symbol in the film world unlike any before him. His casual nakedness and characteristic cool in the Warhol Factory’s irreverent, now-classic films earned attention that crossed gender lines and liberated the male nude as an object of beauty in the cinema.<br/><br/> In this biofilmography, an update and revision of <i>Little Joe, Superstar</i>, Michael Ferguson explores not only Dallesandro’s Warhol years, but his troubled childhood on the streets of New York, in juvenile detention, as physique model, and on the run. Ferguson examines all of Dallesandro’s films: the eight made with Warhol and Morrissey, including the X-rated <i>Frankenstein </i>and <i>Dracula</i>, the post-Factory career in both art-world and low-budget films abroad, and his works as character actor upon his return to America.<br/><br/> Including new interviews with Dallesandro, photographs from the actor’s personal collection, and an extensive biographical section, <i>Joe Dallesandro</i> is the ultimate guide to an underground film icon who, according to Andy Warhol, “everyone was in love with.”<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Ferguson
      </h2>
      
      <p class="authorDescription body article">Michael Ferguson is a lifelong film aficionado and former actor. While he has a keen interest in the horror pictures of the 1930s and forties, his writing has largely been devoted to examinations of the male sex symbol in film. He is the author of&#160;<I>Little Joe, Superstar: The Films of Joe Dallesandro</I>&#160;(1998),&#160;<I>Idol Worship: A Shameless Celebration of Male Beauty in the Movies</I>&#160;(2003; revised edition, 2005), and&#160;<I>Joe Dallesandro: Warhol Superstar, Underground Film Icon, Actor</I>. Ferguson&rsquo;s work has appeared in&#160;<I>Cult Movies</I> and&#160;<I>Bikini</I>&#160;magazines. He lives in Chicago.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ba46a36